function Community() {
    return (
        <div className="feed-post-div">
            <h1>Community Feed Coming Soon!</h1>
        </div>
    );
}

export default Community;